

import {  
  loadFirmwareDataInProgress,
  loadFirmwareDataSuccess,
  loadFirmwareDataFailure,
  loadConfigDataInProgress,
  loadConfigDataSuccess,
  loadConfigDataFailure,
  loadDeviceDataInProgress,
  filesOperationCompleted,
  closeFirmwareDialog,
  closeConfigDialog
} from "../state/files/actions";
import { oktaAuth } from '../auth/okta';
import configData from "../config.json";
import swal from 'sweetalert';
import { oopsSweetAlert } from '../components/SweetAlertMessages';
import { errorSweetAlert } from '../components/SweetAlertMessages';

const serverBasePath=configData.SERVER_API_URL;
let abortController = null;

export const uploadFirmware = (data) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    dispatch(loadFirmwareDataInProgress());
    try {
        const response = await fetch(serverBasePath+"/file/firmware/uploadFile", {
            method: "POST",  
            headers: {
                Authorization: 'Bearer ' + token,       
                'type': 'formData',
            },
            body:data
        });
        dispatch(filesOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(closeFirmwareDialog());
        swal({
            title: "Success",
            text: result.message,
            icon: "success",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
        });
    } catch (e) {
        dispatch(loadFirmwareDataFailure());
        errorSweetAlert(e);
    }
};


export const uploadConfigFile = (data) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    dispatch(loadConfigDataInProgress());
    try {
        const response = await fetch(serverBasePath+"/file/config/uploadFile", {
            method: "POST",  
            headers: {
                Authorization: 'Bearer ' + token,       
                'type': 'formData',
            },
            body:data
        });
        dispatch(filesOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(closeConfigDialog());
        swal({
            title: "Success",
            text: result.message,
            icon: "success",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
        });
    } catch (e) {
        dispatch(loadConfigDataFailure());
       errorSweetAlert(e);
    }
};


export const uploadDefaultFile = (data) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
     dispatch(loadConfigDataInProgress());
     try {
         const response = await fetch(serverBasePath+"/file/default/uploadFile", {
             method: "POST",  
             headers: {
                 Authorization: 'Bearer ' + token,       
                 'type': 'formData',
             },
             body:data
         });
         dispatch(filesOperationCompleted());
         const result = await response.json();
         if(response.status !== 200){
             oopsSweetAlert(result);
             return;
         }
         dispatch(closeConfigDialog());
         swal({
             title: "Success",
             text: result.message,
             icon: "success",
             closeOnClickOutside:false,
             closeOnEsc: false,
             allowOutsideClick: false,
         });
     } catch (e) {
         dispatch(loadConfigDataFailure());
        errorSweetAlert(e);
     }
 };


export const loadFirmwareHistory = (controllerId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadFirmwareDataInProgress());
        const response = await fetch(serverBasePath+"/file/firmwares?controllerId="+controllerId,
        {   method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        dispatch(filesOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(loadFirmwareDataSuccess(result));    
    } catch (e) {
        dispatch(loadFirmwareDataFailure());   
        errorSweetAlert(e);
    }
};

export const loadConfigFileHistory = (serialNumber,searchType) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
      dispatch(loadConfigDataInProgress());
      const response = await fetch(serverBasePath+"/file/configFiles?serialNumber="+serialNumber+"&searchType="+searchType,
        {    
            signal,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        dispatch(filesOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(loadConfigDataSuccess(result));    
    } catch (e) {
      dispatch(loadConfigDataFailure());   
      if (e.name === "AbortError") {
        //errorSweetAlert({message:'The operation was aborted.'}); 
      }
    }
};



export const loadDefaultFileHistory = (serialNumber,searchType) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token'); 
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
      dispatch(loadConfigDataInProgress());
      const response = await fetch(serverBasePath+"/file/defaultFactoryFiles?serialNumber="+serialNumber+"&searchType="+searchType,
        {    
            signal,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        dispatch(filesOperationCompleted());
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(loadConfigDataSuccess(result));    
    } catch (e) {
      dispatch(loadConfigDataFailure());   
      if (e.name === "AbortError") {
        //errorSweetAlert({message:'The operation was aborted.'}); 
      }
    }
};


export const downloadFirmwareFile = (rowId,fileName) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken();
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadDeviceDataInProgress());
            const response = await fetch(serverBasePath+"/file/"+rowId+"/firmware/download",
            {
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status === 500){
                dispatch(filesOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',fileName); 
            document.body.appendChild(link);
            link.click();
            dispatch(filesOperationCompleted()); 
        } catch (e) {   
            dispatch(loadFirmwareDataFailure());
            errorSweetAlert(e);  
        }
    };
};

export const downloadConfigFile = (rowId,fileName) =>  {
    return async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
        try {
            dispatch(loadDeviceDataInProgress());
            const response = await fetch(serverBasePath+"/file/"+rowId+"/config/download",
            {   
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status === 500){
                dispatch(filesOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',fileName); 
            document.body.appendChild(link);
            link.click();
            dispatch(filesOperationCompleted()); 
        } catch (e) {   
            dispatch(loadConfigDataFailure());
            errorSweetAlert(e); 
            
        }
    };
};


export const downloadDefaultFile = (rowId,fileName) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken();
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadDeviceDataInProgress());
            const response = await fetch(serverBasePath+"/file/"+rowId+"/default/download",
            {   
                method: "GET",
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            });
            if(response.status === 500){
                dispatch(filesOperationCompleted()); 
                const error = {'message': 'Internal Server Error'};
                oopsSweetAlert(error);
                return
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',fileName); 
            document.body.appendChild(link);
            link.click();
            dispatch(filesOperationCompleted()); 
        } catch (e) {   
            dispatch(loadConfigDataFailure());
            errorSweetAlert(e); 
            
        }
    };
};

export const deleteConfigFile = (rowId,searchText,searchType) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken();
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadDeviceDataInProgress());
            const response = await fetch(serverBasePath+"/file/delete/configfile/"+rowId,{
            method: "PUT",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }});
            dispatch(filesOperationCompleted()); 
            const result = await response.json();
            if(response.status !==  200){
                oopsSweetAlert(result);
                return;
            }
            swal({
                title: "Success",
                text: result.message,
                icon: "success",
                closeOnClickOutside:false,
                closeOnEsc: false,
                allowOutsideClick: false,
            })
            .then(marked => {
                if (marked) {
                    dispatch(loadConfigFileHistory(searchText,searchType))
                }
            });
        } catch (e) {   
            dispatch(loadConfigDataFailure());
            errorSweetAlert(e); 
        }
    };
};

export const deleteDefaultFile = (rowId,searchText) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken();
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadDeviceDataInProgress());
            const response = await fetch(serverBasePath+"/file/delete/defaultfile/"+rowId,
            {
                method: "PUT",
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json',
                }
            });
            dispatch(filesOperationCompleted()); 
            const result = await response.json();
            if(response.status !==  200){
                oopsSweetAlert(result);
                return;
            }
            swal({
                title: "Success",
                text: result.message,
                icon: "success",
                closeOnClickOutside:false,
                closeOnEsc: false,
                allowOutsideClick: false,
            })
            .then(marked => {
                if (marked) {
                    dispatch(loadDefaultFileHistory(searchText))
                }
            });
        } catch (e) {   
            dispatch(loadConfigDataFailure());
            errorSweetAlert(e); 
        }
    };
};
